import { DashboardCosts } from './dashboard-costs.models';

export class Dashboard {
  bizCostsLargeMedium?: DashboardCosts;
  budgetCosts?: DashboardCosts;
  large: number;
  medium: number;
  micro: number;
  praAcceptedCount?: number;
  praAcceptedPercent?: number;
  praUnderReviewCount: number;
  praUnderReviewPercent: number;
  small?: number;
  smallBusinessCosts?: DashboardCosts;
  totalActs?: number;
  totalSubjects: number;
  remarkTotal: number;
  validityCount?: number;
  omcNoCommentPercent?: number;
  omcProposalPercent?: number;
  omcAcceptedPercent?: number;
  rejectedPercent?: number;

  constructor(item: any) {
    this.bizCostsLargeMedium = new DashboardCosts(item.bizCostsLargeMedium);
    this.budgetCosts = new DashboardCosts(item.budgetCosts);
    this.large = item.large;
    this.medium = item.medium;
    this.micro = item.micro;
    this.small = item.small;
    this.praAcceptedCount = item.praAcceptedCount;
    this.praAcceptedPercent = item.praAcceptedPercent;
    this.praUnderReviewCount = item.praUnderReviewCount;
    this.smallBusinessCosts = new DashboardCosts(item.smallBusinessCosts);
    this.totalActs = item.totalActs;
    this.totalSubjects = item.totalSubjects;
    this.remarkTotal = item.remarkTotal;
    this.praUnderReviewPercent = item.praUnderReviewPercent;
    this.validityCount = item.validityCount;
    this.omcNoCommentPercent = item.omcNoCommentPercent;
    this.omcProposalPercent = item.omcProposalPercent;
    this.omcAcceptedPercent = item.omcAcceptedPercent;
    this.rejectedPercent = item.rejectedPercent;
  }

  static fromJson(json: any): Dashboard {
    return new Dashboard(json);
  }
}
